









































import { Component, Vue } from "vue-property-decorator";

@Component
export default class OHeader extends Vue {
  private isHamMenu = false;
}
